import React from 'react';

import ForecastQueryRenderer from '../../../../../../../ForecastQueryRenderer';
import {RelayProps} from '../../../../../../../relay-helpers/TSRelayConverter';
import TimeRegistrationModalUpdate, {TimeRegistrationModalUpdateQuery} from '../TimeRegistrationModalUpdate';

import type {TimeRegistrationModalUpdate_viewer} from '../__generated__/TimeRegistrationModalUpdate_viewer.graphql';

type TimeRegistrationModalUpdateQueryWrapperProps = {
	timeRegistrationId?: string;
	closeModal: () => void;
};

function TimeRegistrationModalUpdateQueryWrapper({
	timeRegistrationId,
	...modalProps
}: TimeRegistrationModalUpdateQueryWrapperProps): JSX.Element {
	return (
		<ForecastQueryRenderer
			key="query-render-time_reg_modal_update"
			query={TimeRegistrationModalUpdateQuery}
			fetchPolicy={'network-only'}
			modal={true}
			variables={{timeRegistrationId}}
			render={(relayProps: RelayProps<TimeRegistrationModalUpdate_viewer>) => {
				return <TimeRegistrationModalUpdate {...relayProps} {...modalProps} />;
			}}
		/>
	);
}

export default TimeRegistrationModalUpdateQueryWrapper;
